/**
 * @generated SignedSource<<23c79fcdfd38c283a5263d492b6402b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateStudentTargetFocusesInput = {
  updateStudentTargetFocusInputs: ReadonlyArray<UpdateStudentTargetFocusInput>;
};
export type UpdateStudentTargetFocusInput = {
  id: string;
  otherTargetsBlocked: boolean;
};
export type StudentTargetFocusUpdateMutation$variables = {
  input: UpdateStudentTargetFocusesInput;
};
export type StudentTargetFocusUpdateMutation$data = {
  readonly updateStudentTargetFocuses: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly studentTargetFocusNode: ReadonlyArray<{
      readonly id: string;
      readonly otherTargetsBlocked: boolean;
    }> | null | undefined;
  };
};
export type StudentTargetFocusUpdateMutation = {
  response: StudentTargetFocusUpdateMutation$data;
  variables: StudentTargetFocusUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateStudentTargetFocusesPayload",
    "kind": "LinkedField",
    "name": "updateStudentTargetFocuses",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudentTargetFocusNode",
        "kind": "LinkedField",
        "name": "studentTargetFocusNode",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otherTargetsBlocked",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentTargetFocusUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentTargetFocusUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6964b3a8492c60983e9b60c4ef48da2c",
    "id": null,
    "metadata": {},
    "name": "StudentTargetFocusUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation StudentTargetFocusUpdateMutation(\n  $input: UpdateStudentTargetFocusesInput!\n) {\n  updateStudentTargetFocuses(input: $input) {\n    studentTargetFocusNode {\n      id\n      otherTargetsBlocked\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b1f0df49953c972f8b62f8fb13ab5fe";

export default node;
